import { format } from 'date-fns';
import settings from '@/settings.js';
export default function hrTime (value) {
	if (value && value !== null && value !== '') {
		return format(value, settings.viewTimeFormat);
	} else {
		return '';
	}
}



// WEBPACK FOOTER //
// ./src/filters/hrTime.js